import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { IReportFileState } from "@/store/modules/reportFile/state";
import { ReportFileMutations } from "@/store/modules/reportFile/mutations";

export enum ReportFileActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_REPORT_FILE",
}

export const actions: ActionTree<IReportFileState, IRootState> = {
  async [ReportFileActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/reports/report/user-report/list", {
        params: params,
      });
      commit(ReportFileMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch job data provider error: ", error);
    }
  },
};
